import { render } from "./TheCouponNameAndComment.vue?vue&type=template&id=5ffe9008&scoped=true"
import script from "./TheCouponNameAndComment.vue?vue&type=script&lang=js"
export * from "./TheCouponNameAndComment.vue?vue&type=script&lang=js"

import "./TheCouponNameAndComment.vue?vue&type=style&index=0&id=5ffe9008&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ffe9008"

export default script